import Game from './scenes/game/Game';
import Intro from './scenes/intro/Intro';

export default {
  /**
     * Add your scene classes here. Simply put the scene class.
     * Ex: `scenes: [MyScene,MyOtherScene]`
     * @type {{KEY:string}[]}
     */
  scenes: [Intro, Game],

  /**
     * Set the first scene that should be loaded here. Must match one of the scenes' key found in the scenes array.
     * It is recommended you put `MyScene.KEY` here instead of using a string.
     * @type {string}
     */
  startScene: Intro.KEY,
  // startScene: Game.KEY,

  currentScene: 'Intro', // "Intro", "Game"
  gameMode: 'lower', // 'upper', 'lower'
  gameStyle: 'Neon', // "Clsc", "Camo", "Wood", "Sprng", "Wntr", "Atm", "Smr", "Spc", "Uncrn", "Neon"
  gameOver: false,
  gamePaused: false,
  gameMuted: false,
  styleFont: null,
  moves: 0,
  bestMoves: 0,
  score: 0,
  updateCounter: 0,
  shuffleCounter: 0,
  initShuffleCounter: 100,
  swappedCells: [],
  anim: null,
  emptySpaces: 4,

  classicSkin: ['_Blue', '_Grn', '_Orng', '_Prp', '_Red'],
  camoSkin: ['1', '2', '3', '4'],
  woodSkin: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
  sprngSkin: ['_Pnk', '_Blue', '_Prp', '_Ylw'],
  wntrSkin: ['_Red', '_Grn'],
  neonSkin: ['_1', '_2', '_3', '_4', '_5']
};
